export const EMPLOYEE_PICKER_EMPTY_MESSAGES = {
  noDepartment: 'Участок не выбран или не содержит сотрудников.',
  emptyDepartment: 'Участок не содержит сотрудников.',
  noSuitableEmployees: 'Подходящие сотрудники не найдены',
  noEmployees: 'Сотрудники не найдены',
  loading: 'Загрузка сотрудников…'
} as const;

export type EmployeePickerEmptyMessageParams = {
  hasDepartment: boolean;
  showAllEmployees: boolean;
  currentEmployeesCount: number;
  allDepartmentEmployeesCount: number;
  isLoading?: boolean;
  noDepartmentMessage?: string;
};

export function getEmployeePickerEmptyMessage({
  hasDepartment,
  showAllEmployees,
  currentEmployeesCount,
  allDepartmentEmployeesCount,
  isLoading = false,
  noDepartmentMessage = EMPLOYEE_PICKER_EMPTY_MESSAGES.noDepartment
}: EmployeePickerEmptyMessageParams): string {
  if (!hasDepartment) {
    return noDepartmentMessage;
  }

  if (isLoading) {
    return EMPLOYEE_PICKER_EMPTY_MESSAGES.loading;
  }

  if (currentEmployeesCount === 0 && allDepartmentEmployeesCount === 0) {
    return EMPLOYEE_PICKER_EMPTY_MESSAGES.emptyDepartment;
  }

  if (
    !showAllEmployees &&
    currentEmployeesCount === 0 &&
    allDepartmentEmployeesCount > 0
  ) {
    return EMPLOYEE_PICKER_EMPTY_MESSAGES.noSuitableEmployees;
  }

  return EMPLOYEE_PICKER_EMPTY_MESSAGES.noEmployees;
}
